import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./disclaimer-dialog-body.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./disclaimer-dialog-body.component.scss?ngResource";
import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { DisclaimerDialogBodyConstants } from "./disclaimer-dialog-body.constants";
import { AppConfig } from "../../../app.config";
import { RequestStatusService } from "../../../shared/services/request-status/request-status.service";
import { SharedConstants } from "../../../shared/constants/shared.constants";
let DisclaimerDialogBodyComponent = class DisclaimerDialogBodyComponent {
    dialogRef;
    router;
    http;
    requestStatusService;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    disclaimerTitle = "";
    disclaimerContent = "";
    acceptDisclaimerURL = DisclaimerDialogBodyConstants.ACCEPT_DISCLAIMER_URL;
    acceptButtonLabel = DisclaimerDialogBodyConstants.ACCEPT_DISCLAIMER_TEXT;
    httpSubscription;
    constructor(dialogRef, router, http, requestStatusService) {
        this.dialogRef = dialogRef;
        this.router = router;
        this.http = http;
        this.requestStatusService = requestStatusService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
        this.disclaimerTitle = AppConfig.settings.disclaimer.title;
        this.disclaimerContent = "<p>" + AppConfig.settings.disclaimer.content + "</p>";
    }
    ngOnInit() {
    }
    acceptDisclaimer($event) {
        this.requestStatusService.showBusySpinner(DisclaimerDialogBodyConstants.ACCEPT_DISCLAIMER_TEXT);
        this.httpSubscription = this.http.post(this.acceptDisclaimerURL, {})
            .subscribe(response => {
            this.closeDisclaimer();
            this.requestStatusService.removeBusySpinner(DisclaimerDialogBodyConstants.ACCEPT_DISCLAIMER_TEXT);
        });
    }
    closeDisclaimer() {
        this.dialogRef.close(true);
    }
    static ctorParameters = () => [
        { type: MatDialogRef },
        { type: Router },
        { type: HttpClient },
        { type: RequestStatusService }
    ];
};
DisclaimerDialogBodyComponent = __decorate([
    Component({
        selector: "app-dialog-body",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], DisclaimerDialogBodyComponent);
export { DisclaimerDialogBodyComponent };
